import {
    SequentialMockAdapter,
  } from '@ama-sdk/core';
  import {
    getMockAdapter,
    getMockScenario,
  } from '@refx/shared-common';
  import {
    mockMaps,
  } from '../../../e2e-playwright-customization/config/mock-map';
  
  /**
   * returns true iff the scenario is a path to a ALF logs file
   *
   * @param scenario scenario name provided as get/post parameter
   * @returns true iff the scenario is a path to a ALF logs file
   */
  export function isAlfMockScenario(scenario?: string): boolean {
    return !!scenario && scenario.endsWith('.bin');
  }
  
  export const mockAdapter: SequentialMockAdapter = getMockAdapter(mockMaps[getMockScenario() || 'disruptedMultiBoundsFixedDate']);  